import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import * as React from 'react'
import { DownloadBlock } from '../../blocks.state'

export const DownloadBlockLayout = (props: DownloadBlock & { id: string }) => {
  const { id, label, title, intro, items } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section id={id} ref={ref} className={cn('block block--download ls-block-spacing', inView && 'inview')}>
      <div className="block__inner ls-container">
        <div className="block__layout ls-columns">
          {(label || title || intro) && (
            <header className="block__header ls-columns__header">
              <div className="block__header-inner ls-reversed-column">
                {title && (
                  <h2 id={slugify(title)} className="block__title title--l">
                    {title}
                  </h2>
                )}
                {label && <p className="block__label">{label}</p>}
              </div>
              {intro && <p className="block__intro" dangerouslySetInnerHTML={{ __html: intro }} />}
            </header>
          )}

          <div className="block__content ls-columns__main">
            {items && items.length > 0 && <ListLayout listClassName="block__list" items={items} />}
          </div>

          {/* NB: Van Oord currently doesn't use block links in the download block  */}
          {/* {(hasPrimaryUpdater || hasSecondaryUpdater) && (
            <footer className="block__footer ls-columns__sidebar">
              <div className="ls-clickables">
                {hasPrimaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind={showUpdaterAsLink ? 'link' : 'button'}
                      {...primaryUpdater}
                      className={
                        showUpdaterAsLink
                          ? 'block__clickable block__clickable--secondary'
                          : 'block__clickable block__clickable--primary'
                      }
                      onClick={() =>
                        pushDatalayer({
                          category: 'DownloadBlock',
                          action: primaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
                {hasSecondaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind="link"
                      {...secondaryUpdater}
                      className="block__clickable block__clickable--secondary"
                      onClick={() =>
                        pushDatalayer({
                          category: 'DownloadBlock',
                          action: secondaryUpdater.title
                        })
                      }
                    />
                  </div>
                )}
              </div>
            </footer>
          )} */}
        </div>
      </div>
    </section>
  )
}

export const ListLayout = (props: { items: DownloadBlock['items']; listClassName?: string; nested?: boolean }) => {
  if (props.items && props.items.length > 0) <></>
  return (
    <ul className={`blocklist ${props.listClassName || ''}`}>
      {props.items.map((item, index) => {
        if (!item.url) return <></>
        return <ItemLayout key={`download-${index}`} {...item} nested={props.nested} />
      })}
    </ul>
  )
}

const ItemLayout = (props: { title: string; text?: string; url: string; nested?: boolean }): JSX.Element => {
  const { title, url, text, nested } = props
  return (
    <li className="blocklist__item">
      <a
        download={true}
        target="_blank"
        rel="noopener noreferrer"
        href={url}
        className={nested ? '' : 'blocklist__link'}
        onClick={() => pushDatalayer({ category: 'Downloads', action: title })}
      >
        <div className="blocklist__text">
          {title && <p className="blocklist__title title--s">{title}</p>}
          {text && <p className="blocklist__subtitle">{text}</p>}
        </div>
      </a>
    </li>
  )
}
